import Vue from 'vue'
import VueRouter from 'vue-router';
import i18n from '@/i18n.js'

import PreMatch from "@/components/PreMatch.vue"
import Overview from "@/components/Overview.vue"
import ShootMap from "@/components/ShootMap.vue"
import Playbyplay from "@/components/Playbyplay.vue"
import BoxScore from "@/components/BoxScore.vue"
import Globals from "@/components/Globals.vue"
import Leaders from "@/components/Leaders.vue"


let routes = [

    { path: '/', redirect: { path: i18n.locale } },

    // en
    { path: '/en', name: 'en.home' },
    { path: '/en/standings-app', name: 'en.standings' },
    { path: '/en/:id_match', redirect: { name: 'en.overview' } },
    { path: '/en/:id_match/overview', name: 'en.overview', components: { overview: Overview } },
    { path: '/en/:id_match/stats', name: 'en.stats', redirect: { name: 'en.boxscore' } },
    { path: '/en/:id_match/stats/boxscore', name: 'en.boxscore', components: { boxscore: BoxScore } },
    { path: '/en/:id_match/stats/leaders', name: 'en.leaders', components: { leaders: Leaders } },
    { path: '/en/:id_match/stats/globals', name: 'en.globals', components: { globals: Globals } },
    { path: '/en/:id_match/shootmap', name: 'en.shootmap', components: { shootmap: ShootMap } },
    { path: '/en/:id_match/playbyplay', name: 'en.playbyplay', components: { playbyplay: Playbyplay } },
    { path: '/en/:id_match/prematch', name: 'en.prematch', components: { prematch: PreMatch } },


    // es
    { path: '/es', name: 'es.home' },
    { path: '/es/clasificacion-app', name: 'es.standings' },
    { path: '/es/:id_match', redirect: { name: 'es.overview' } },
    { path: '/es/:id_match/resumen', name: 'es.overview', components: { overview: Overview } },
    { path: '/es/:id_match/estadisticas', name: 'es.stats', redirect: { name: 'es.boxscore' } },
    { path: '/es/:id_match/estadisticas/ficha', name: 'es.boxscore', components: { boxscore: BoxScore } },
    { path: '/es/:id_match/estadisticas/lideres', name: 'es.leaders', components: { leaders: Leaders } },
    { path: '/es/:id_match/estadisticas/globales', name: 'es.globals', components: { globals: Globals } },
    { path: '/es/:id_match/cartadetiro', name: 'es.shootmap', components: { shootmap: ShootMap } },
    { path: '/es/:id_match/jugadas', name: 'es.playbyplay', components: { playbyplay: Playbyplay } },
    { path: '/es/:id_match/previa', name: 'es.prematch', components: { prematch: PreMatch } },


    { path: '/*', redirect: { path: '/' } }
]

Vue.use(VueRouter)


let router = new VueRouter({
    mode: "history",
    routes: routes,
    scrollBehavior(to, savedPosition) {
        // if (to.params.goTop) {
        //     return { x: 0, y: 1 }
        // } else {
        return savedPosition
        // }
    }
})

export default router;